import type { RouteRecordRaw } from 'vue-router'
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth'
import { allDefaultstoreRoutes } from '@/pages/defaultstore/routes'

export const defaultstoreRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.default_store, action: PermissionAction.enum.view },
  },
  children: [
    ...allDefaultstoreRoutes,
  ],
}
